import React from 'react';
import styled from "styled-components";
import calibersImage from "../../images/hero_bg_calibers.png";
import calibers_main_image from "../../images/calibers_main_image.png";
import Breadcrumbs from "../../components/Breadcrumbs";
import JoinTeamForm from "../../components/JoinTeamForm";
import Advantages from "../../components/manufacturing/Advantages";

const StyledManufacturingCalibers = styled.main`
    color: #171717;
    overflow: hidden;

    .container {
        width: min(1200px, calc(100% - 40px));
        margin: 0 auto;
    }

    h1, h2, p {
        margin: 0;
    }

    h1 {
        margin: 38px 0 42px;
        font-size: 28px;
        font-weight: 600;
        @media screen and (max-width: 1919px) {
            margin: 38px 0 28px;
        }
    }

    h2 {
        font-size: 28px;
        font-weight: 600;
    }

    .hero {
        min-height: 662px;
        display: flex;
        align-items: flex-start;
        padding: 109px 0 32px;
        background: linear-gradient(120deg, rgba(17, 19, 22, .55), rgba(17, 19, 22, .35)), url(${calibersImage}) center / cover;
        @media screen and (max-width: 1919px) {
            padding: 54px 0;

        }
    }

    .cards {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 30px;
        align-items: start;
        @media screen and (max-width: 1919px) {
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(3, 1fr);
            gap: 20px 30px;
            /* 01 */
            .card {
                .number {
                    margin: 0;
                }
            }

            .card {
                margin: 0 !important;
            }

            .card:nth-child(1) {
                grid-column: 1;
                grid-row: 1;
            }

            /* 02 */
            .card:nth-child(2) {
                grid-column: 2;
                grid-row: 2;
            }

            /* 03 */
            .card:nth-child(3) {
                grid-column: 3;
                grid-row: 1;
            }

            /* 04 */
            .card:nth-child(4) {
                grid-column: 3;
                grid-row: 3;
            }
        }
        @media screen and (max-width: 999px) {
            display: flex;
            flex-direction: column;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: repeat(4, 1fr);
            gap: 28px;
            .card {
                width: 100%;
                gap: 28px;
                min-height: 0;

                .number {
                    margin: 0;
                }
            }
        }
    }

    .card {
        min-height: 222px;
        padding: 27px 30px;
        border-radius: 10px;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-weight: 400;
    }

    .card:nth-child(2) {
        margin-top: 247px;
        background: #5b77cb;
        color: #fff;
    }

    .card:nth-child(3) {
        margin-top: 0;
    }

    .card:nth-child(4) {
        margin-top: 0;
    }

    .number {
        display: block;
        margin-bottom: 40px;
        color: #5b77cb;
        font-size: 18px;
        font-weight: 500;
    }

    .card:nth-child(2) .number {
        color: #fff;
    }

    .card p {
        font-size: 20px;
        line-height: 1.4;
    }

    .direction {
        padding: 110px 0;
        @media screen and (max-width: 1919px) {
            padding: 80px 0;
        }
    }

    .direction h2 {
        margin-bottom: 36px;
    }

    .direction-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 55px;
        align-items: center;
    }

    .direction-image {
        display: block;
        width: 100%;
        height: 349px;
        border-radius: 10px;
        object-fit: cover;
    }

    .direction ul {
        margin: 0;
        padding: 0 0 0 26px;
        list-style: none;
    }

    .direction li {
        position: relative;
        padding: 0 0 42px;
        font-size: 20px;
        line-height: 1.4;

        @media screen and (max-width: 1919px) {
            padding: 0 0 36px;
        }

        &:last-child {
            padding-bottom: 0;
        }
    }

    .direction li:last-child {
        margin-bottom: 0;
    }

    .direction li::after {
        content: "";
        position: absolute;
        left: -34px;
        top: 8px;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #5b77cb;
    }

    .direction li {
        &::before {
            content: "";
            position: absolute;
            left: -27px;
            width: 1px;
            height: 100%;
            top: 0;

            background: #d5d5d5;
        }

        &:first-child {
            &::before {
                top: 8px;
                height: calc(100% - 8px);
            }
        }

    }

    .contact {
        padding: 0 0 110px;
        @media screen and (max-width: 1919px) {
            padding: 0 0 90px;
        }
    }

    .contact h2 {
        margin-bottom: 20px;
    }

    .contact p {
        max-width: 610px;
        margin-bottom: 28px;
        font-size: 18px;
        line-height: 1.4;

        &:last-child {
            max-width: none;
            padding-top: 26px;
            font-weight: 400;
            margin-bottom: 0;

            a {
                font-weight: 500;
                color: #354D95;
            }
        }
    }

    .contact button {
        height: auto;
        padding: 16px 28px;
        border: 0;
        background: #5b77cb;
        color: white;
        font-weight: 500;
        font-size: 20px;
        border-radius: 4px;
        line-height: 140%;
    }

    .contact button:hover {
        background: #354d95 !important;
        color: white !important;
    }

    @media (max-width: 999px) {

        h1 {
            margin: 30px 0;
            font-size: 24px;
        }

        h2 {
            font-size: 24px;
        }

        .hero {
            min-height: auto;
            padding: 60px 0;
        }

        .card, .card:nth-child(2), .card:nth-child(3), .card:nth-child(4) {
            margin: 0;
            padding: 20px;
        }

        .number {
            margin-bottom: 24px;
        }

        .direction li {
            font-size: 20px;
            font-weight: 400;
        }

        .card p {
            font-size: 18px;
            font-weight: 400;
        }

        .direction {
            padding: 64px 0;
        }

        .direction-content {
            grid-template-columns: 1fr;
            gap: 32px;
        }

        .direction-image {
            min-height: 240px;
        }

        .contact {
            padding-bottom: 106px;
        }
    }
`;

const cards = [
    "Производство калибров по ГОСТ, ТУ и международным стандартам",
    "Производство под заказ и по чертежам",
    "Сертификация и контроль качества",
    "Собственная лаборатория контроля качества",
];

const directions = [
    "Резьбовые калибры: пробки, кольца, контркалибры",
    "Гладкие калибры и калибр скоба",
    "Конусные и специальные калибры",
    "Калибры по чертежам и ТЗ заказчика",
    "Изготавливаем калибры Stub ACME, API, UN, NPT и другие — по эскизам и 3D-моделям",
];

const advantagesItems = [{
    title: 'Партнёрство с лидерами промышленности',
    text: 'Сотрудничество с крупнейшими промышленными компании и заводами России и СНГ'
}, {
    title: 'Экспертная поддержка технолога‑метролога',
    text: 'Консультация технолога-метролога'
}, {
    title: 'Инновационные решения и импортозамещение',
    text: 'Нестандартное решения и импортозамещение'
}, {
    title: 'Гарантия качества и полная документация',
    text: 'Вся выпускаемая продукция проходит контроль качества, и сопровождается паспортом изделия, поверкой либо свидетельством о контроле'
}]

function ManufacturingCalibers() {

    return (
        <StyledManufacturingCalibers>
            <div className="container">
                <Breadcrumbs/>
                <h1>Промышленные калибры высокого качества по низким ценам!</h1>
            </div>
            <section className="hero" aria-label="Изготовление калибров">
                <div className="container cards">
                    {cards.map((text, index) => <article className="card" key={text}>
                        <span className="number">{String(index + 1).padStart(2, "0")}</span>
                        <p>{text}</p>
                    </article>)}
                </div>
            </section>
            <section className="container direction">
                <h2>Основное направление</h2>
                <div className="direction-content">
                    <img className="direction-image" src={calibers_main_image} alt="Измерительные инструменты"/>
                    <ul>{directions.map(text => <li key={text}>{text}</li>)}</ul>
                </div>
            </section>
            <section className="container contact">
                <JoinTeamForm title={"Изготовим калибры под ваши задачи"} text={"Оставьте заявку — и мы подберём калибры под ваше производство, рассчитаем цену и сроки."}/>
            </section>
            <Advantages items={advantagesItems}/>
        </StyledManufacturingCalibers>
    );
}

export default ManufacturingCalibers;
